export enum SessionStorageEnum {
  RELOAD_DETECETOR = 'reload-detector'
}
